<template>
  <div class="popup_wrap" style="width:800px; height:520px;">
    <button
      type="button"
      class="layer_close"
      @click="popClose()"
    >
      close
    </button>
    <div class="popup_cont">
      <!-- popup_cont -->
      <h1 class="page_title">
        {{ $t('msg.ONEX010P100.032') }}
      </h1>
      <div class="content_box">
        <!--        <h2 class="content_title">Booking</h2>-->
       <p class="color_red font_12 mb5" v-if="type === 'D' || type === 'F'">{{ $t('msg.NEWB020P030.016') }}</p>
       <p class="color_red font_12 mb5" v-if="type === 'D' || type === 'F'">{{ $t('msg.NEWB020P030.018') }}</p>
        <!-- SR 1723844 : 호출 화면에서 넘긴 첨부 안내 문구 -->
        <div v-for="(guideText, idx) in guideTextList" :key="idx" class="mb5">
          <p class="color_red font_12 mb5">{{ guideText }}</p>
        </div>
        <DEXT5Upload
          ref="dextupload_docPop"
          id="dextupload_docPop"
          width="100%"
          height="200px"
          :single="singleFileYn"
          :file-info="parentInfo"
          :file-ext="fileExt"
          :category="categoryInfo.length > 0"
          :category-info="categoryInfo"
        />
      </div>
    </div>
    <div class="mt10 text_center">
      <a class="button blue lg" @click="popClose()">{{ $t('msg.VOSD100.041') }}</a>
    </div>
  </div>
</template>

<script>
import DEXT5Upload from '@/components/DEXT5Upload'

export default {
  name: 'DocUploadPop',
  components: { DEXT5Upload },
  props: {
    singleFileYn: {
      type: Boolean,
      default: false
    },
    parentInfo: {
      type: Array,
      default: function () {
        return []
      }
    },
    categoryInfo: {
      type: Array,
      default: () => []
    },
    //SR 1723844 : 첨부 안내 문구(호출 화면에서 전달). 미전달 시 기존과 동일하게 표시 없음
    guideTextList: {
      type: Array,
      default: () => []
    },
    fileExt: {
      type: String,
      default: 'bmp,jpg,jpeg,png,pdf,xls,xlsx,doc,docx,zip,rar',
      required: false
    },
    type: {
       type: String,
       default: ''
    }
  },
  created () {
     if (this.type === 'F' || this.type === 'D') {
      this.fileExt = 'bmp,jpg,jpeg,png,pdf,xls,xlsx,doc,docx,rar'
     }
    // console.log('--- categoryInfo ---')
    // console.log(this.categoryInfo)
    // test
    // this.fileInfo.guid[i], this.fileInfo.originalName[i], '/', this.fileInfo.size[i], this.fileInfo.fileId[i], uploadId
    // this.fileInfo = [{ guid: '21915747-F71E-930A-D23F-FD1689A1A8E6', originalName: '스크린샷 2021-08-03 오후 3.22.04.png', size: '16958', fileId: '123', status: 'complete' }, { guid: '129C42D8-0F13-AE72-2D32-85D94A8393FC', originalName: '스크린샷 2021-08-04 오후 1.15.45.png', size: '84930', fileId: '124', status: 'complete' }]
  },
  methods: {
    setFileInfo: function (parentInfo) {
      // let $vm = this

      if (this.$refs.dextupload_docPop !== undefined) {
        this.$refs.dextupload_docPop.setFileInfo(parentInfo)
        // this.$emit('arrange')
      }
    },
    getMaxFileSize () {
      return 20 * 1024 * 1024
    },
    validateFileSize (fileList) {
      const maxSize = this.getMaxFileSize()

      const exceededFile = fileList.find(file => {
        const fileSize = Number(file.size || 0)
        return fileSize > maxSize
      })
      if (exceededFile) {
        this.$ekmtcCommon.alertDefault(this.$t('msg.NEWB020P030.019'))
        return false
      }
      return true
    },
    isRestrictedAttachmentType () {
      return this.type === 'D' || this.type === 'F'
    },

    isZipFile (fileName) {
      return /\.zip$/i.test((fileName || '').trim())
    },

    getUploadFileName (file) {
      return file.originalName || file.name || ''
    },

    validateZipFile (fileList) {
      if (!this.isRestrictedAttachmentType()) {
        return true
      }

      const invalidZipFile = fileList.find(file => {
        const fileName = this.getUploadFileName(file)
        return this.isZipFile(fileName)
      })

      if (invalidZipFile) {
        this.$ekmtcCommon.alertDefault(this.$t('msg.NEWB020P030.017'))
        return false
      }

      return true
    },
    async popClose () {
      const isUploading = this.$refs.dextupload_docPop.isUploading()

      if (isUploading) {
        // 아직 업로드 중.....
        console.log('아직 업로드 중')
        return
      }

      let file = this.$refs.dextupload_docPop.getFileInfo()

       // 파일 크기 검사
      if (!this.validateFileSize(file)) {
        return
      }
      // ZIP 검사
      if (!this.validateZipFile(file)) {
        return
      }

      // 카테고리 선택이 필요한 경우
      if (this.categoryInfo.length > 0 && file.length > 0) {
        let isCategory = true
        file.forEach(f => {
          if (f.category === '') {
            isCategory = false
          }
        })

        if (!isCategory) {
          await this.$ekmtcCommon.asyncAlertMessage({ message: 'Please select category' })
          return
        }
      }
      //~ 카테고리 선택이 필요한 경우

      // this.$refs.dextupload_docPop.ResetDext()
      this.$emit('set-dext-file-info', file)

      // this.$ekmtcCommon.layerClose('.doc_req_pop .popup_dim')
      this.$emit('close')
      // return false
    }
  }
}
</script>
